import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { AdminService } from '../../services/admin.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-reports-appeals',
  templateUrl: './reports-appeals.component.html',
  styleUrls: ['./reports-appeals.component.scss']
})
export class ReportsAppealsComponent implements OnInit {
  activeTab: 'reports' | 'appeals' = 'reports';
  
  reports: any[] = [];
  appeals: any[] = [];
  
  dtOptions: DataTables.Settings = {};
  dtTriggerReports: Subject<any> = new Subject();
  dtTriggerAppeals: Subject<any> = new Subject();

  renderReports = true;
  renderAppeals = true;

  // Modal State
  isModalOpen = false;
  modalTitle = '';
  modalMessage = '';
  confirmAction: () => void = () => {};

  constructor(
    private adminService: AdminService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      processing: true
    };
    this.fetchReports();
    this.fetchAppeals();
  }

  setTab(tab: 'reports' | 'appeals') {
    this.activeTab = tab;
  }

  refreshReportsTable() {
    this.renderReports = false;
    setTimeout(() => {
      this.renderReports = true;
    }, 10);
  }

  refreshAppealsTable() {
    this.renderAppeals = false;
    setTimeout(() => {
      this.renderAppeals = true;
    }, 10);
  }

  fetchReports() {
    this.adminService.getReports().subscribe((res: any) => {
      const data = res?.data || res || [];
      // Filter out reports that might have been processed if backend sends them
      this.reports = data.filter((r: any) => r.status === 'pending' || !r.status);
      this.refreshReportsTable();
    }, err => {
      this.toastr.error('Failed to load reports');
    });
  }

  fetchAppeals() {
    this.adminService.getAppeals().subscribe((res: any) => {
      const data = res?.data || res || [];
      this.appeals = data.filter((a: any) => a.status === 'pending' || !a.status);
      this.refreshAppealsTable();
    }, err => {
      this.toastr.error('Failed to load appeals');
    });
  }

  openConfirmModal(title: string, message: string, action: () => void) {
    this.modalTitle = title;
    this.modalMessage = message;
    this.confirmAction = action;
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }

  onConfirmModal() {
    this.confirmAction();
  }

  actionReport(report: any, action: 'flag' | 'dismiss') {
    const title = action === 'flag' ? 'Flag Account' : 'Dismiss Report';
    const message = `Are you sure you want to ${action} this report?`;
    this.openConfirmModal(title, message, () => {
      this.adminService.actionReport(report._id || report.id, action).subscribe(() => {
        this.toastr.success(`Report ${action}ed successfully`);
        this.reports = this.reports.filter(r => (r._id || r.id) !== (report._id || report.id));
        this.refreshReportsTable();
        this.closeModal();
      }, err => {
        this.toastr.error(`Error trying to ${action} report`);
      });
    });
  }

  actionAppeal(appeal: any, action: 'release' | 'block') {
    const title = action === 'release' ? 'Release Account' : 'Block Permanently';
    const message = `Are you sure you want to ${action} this account?`;
    this.openConfirmModal(title, message, () => {
      this.adminService.actionAppeal(appeal._id || appeal.id, action).subscribe(() => {
        this.toastr.success(`Account ${action}ed successfully`);
        this.appeals = this.appeals.filter(a => (a._id || a.id) !== (appeal._id || appeal.id));
        this.refreshAppealsTable();
        this.closeModal();
      }, err => {
        this.toastr.error(`Error trying to ${action} account`);
      });
    });
  }
}
